import { userManagementService } from "../../service/userManagementService";
import router from "../../router";

export const namespaced = true;

const getDefaultState = () => {
  return {
    users: [],
    consultant: [],
    userProfile: [],
    consultantStatistics:null,
  };
};
export const state = getDefaultState();
// export const state = {
//   bazarPageData: null,
// }

export const getters = {
  getUsers(state) {
    return state.users;
  },
  getUserProfile(state) {
    return state.userProfile;
  },
  getConsultant(state) {
    return state.consultant;
  },
  getConsultantStatistics(state) {
    return state.consultantStatistics;
  }
};
export const mutations = {
  SET_USER(state, payload) {
    state.users = payload;
  },
  SET_USER_PROFILE(state, payload) {
    state.userProfile = payload;
  },
  SET_CONSULTANT(state, payload) {
    state.consultant = payload;
  },
  SET_CONSULTANT_STATISTICS(state, payload) {
    state.consultantStatistics = payload;
  },
  RESET_STATE(state) {
    Object.assign(state, getDefaultState());
  }
};

export const actions = {
  async searchUser({ commit }, payload) {
    const { data } = await userManagementService().searchUser(payload);
    commit("SET_USER", data.data.docs);
    return data.data;
  },
  async fetchUserProfile({ commit }, payload) {
    const { data } = await userManagementService().fetchUserProfile(payload);
    commit("SET_USER_PROFILE", data.data);
    return data.data;
  },
  async changeStatus({ commit }, payload) {
     await userManagementService().changeStatus(payload);
  },
  async makeUserAdmin({ commit }, payload) {
    await userManagementService().makeUserAdmin(payload);
  },
  async makeUserNormal({ commit }, payload) {
    await userManagementService().makeUserNormal(payload);
  },
  async editUserProfile({ commit }, payload) {
    await userManagementService().editUserProfile(payload);
  },
  // async searchConsultant({ commit }, payload) {
  //   const { data } = await userManagementService().searchConsultant(payload);
  //   commit("SET_CONSULTANT", data.data.docs);
  //   return data.data;
  // },
  //
  //
  // async fetchUserProfile({ commit }, payload) {
  //   const { data } = await userManagementService().fetchUserProfile(payload);
  //   //console.log("dataSearch-------->", data);
  //   commit("SET_USER_PROFILE", data.data);
  //   return data.data;
  // },

  resetState({ commit }) {
    commit("RESET_STATE");
  }
};
